import { getFunctions, httpsCallable } from 'firebase/functions';
import { FirebaseHandlers } from '../../../../core/firebase';

const functions = getFunctions();
const invoiceQuickFn: any = httpsCallable(functions, 'stripe-invoice-quick');

export interface IConversationPaymentInfo {
  customerId: string;
  productId: string;
  priceId: string;
  description: string;
  production: boolean;
  invoiceId?: string;
  emblem: string;
}

export const quickInvoice = async (input: Omit<IConversationPaymentInfo, 'production'>): Promise<void> => {
  // await FirebaseHandlers.run<IConversationPaymentInfo, void>({...input, production: process.env.NODE_ENV === 'production'}, invoiceQuickFn);
  console.warn('@TODO remove production override');
  await FirebaseHandlers.run<IConversationPaymentInfo, void>({...input, production: false}, invoiceQuickFn);
}

